export default "__VITE_ASSET__ee3c7b81__"